export const redToGreenGradientContrasted = [
  '#D73B3B',
  '#DA5641',
  '#DB6C44',
  '#DB7E46',
  '#DB8C46',
  '#DB9446',
  '#D4A24E',
  '#C6A95B',
  '#B7B067',
  '#A7B673',
  '#97BB7D',
  '#86BF85',
  '#76C28B',
  '#68C291',
  '#5BC196',
  '#4FC09A',
  '#45BD9C',
  '#3DB99B',
  '#3AB08B',
];
